module.exports = __webpack_public_path__ + "img/transferes02.8a97b3d4.jpg";